import { Link } from "react-router-dom";

const Plans = () => {
  return (
    <div>
      <div className="plan-wrapper">
        <div className="plan">
          <div className="inner">
            <h5 className="fw-bold">BASIC</h5>
            <h4>1000 - $3,999</h4>
            <p>10%</p>
            <p>DAILY</p>
            <p>For 14 days</p>
            <p>
              Total ROI: <br /> 140%
            </p>

            <Link to="/dashboard/deposit">
              <button className="btn btn-outline">Choose Plan</button>
            </Link>
          </div>
        </div>

        <div className="plan">
          <div className="inner">
            <h5 className="fw-bold">GOLD</h5>
            <h4>$4,000 - $11,999</h4>
            <p>12.5%</p>
            <p>DAILY</p>
            <p>For 14 days</p>
            <p>
              Total ROI: <br /> 175%
            </p>

            <Link to="/dashboard/deposit">
              <button className="btn ">Choose Plan</button>
            </Link>
          </div>
        </div>

        <div className="plan">
          <div className="inner">
            <h5 className="fw-bold">PLATINUM</h5>
            <h4>$12,000 - $49,999</h4>
            <p>15%</p>
            <p>DAILY</p>
            <p>For 14 days</p>
            <p>
              Total ROI: <br /> 210%
            </p>

            <Link to="/dashboard/deposit">
              <button className="btn btn-outline">Choose Plan</button>
            </Link>
          </div>
        </div>

        <div className="plan">
          <div className="inner">
            <h5 className="fw-bold">DIAMOND</h5>
            <h4>$50,000+</h4>
            <p>20%</p>
            <p>DAILY</p>
            <p>For 14 days</p>
            <p>
              Total ROI: <br /> 280%
            </p>

            <Link to="/dashboard/deposit">
              <button className="btn btn-outline">Choose Plan</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
